import React from "react";
import SiteBanner from "../../components/site-banner/site-banner";
import MenuSuperior from "components/menu-superior/menu-superior";
import SiteFooter from "../../components/site-footer/site-footer.component";
import NavPanel, {FIXED_FROM} from "components/nav-panel/nav-panel.component";
import ViewContainer from "../../components/view-container/view-container.component";
import GoToSky from "components/go-to-sky/go-to-sky.component";

import "./pagina-principal.page.scss";

// Ancho minimo de pantalla en que se puede mostrar el menú dentro del cuerpo de la pagína
const VISIBLE_IN_BODY_FROM = 1200;
class PaginaPrincipal extends React.Component {
  constructor(props) {
    super(props);
    let me = this;
    me.toggleMenu = me.toggleMenu.bind(me);
    me.headerCmp = React.createRef();
    me.navPanelCmp = React.createRef();
    me.menuShown = false;
    me.state = {
      withLeftMargin: false,
      sidenavMode: me.getInitialSidenavMode()
    };
  }
  render() {
    let me = this;
    const { sidenavMode } = me.state;
    return (
      <div className={`page--sidenav-${sidenavMode}`}>
        <main>
          <div className="page-body">
            <ViewContainer />
          </div>
        </main>
      </div>
    );
  }
  getInitialSidenavMode() {
    let me = this;
    //Oculto
    if (!me.canSidenavBeShownInPageBody()) {
      return "hidden";
    }
    if (me.shouldSidenavBeFixed()) {
      return "fixed";
    }
    return "docked";
  }
  /**
   * Indica si el menu puede ser mostrádo como parte del cuerpo de la pagina
   */
  canSidenavBeShownInPageBody() {
    return document.body.offsetWidth >= VISIBLE_IN_BODY_FROM;
  }
  /**
   * Indica si el menú deberia pasar a modo estatico
   */
  shouldSidenavBeFixed() {
    return (
      document.documentElement.scrollTop > FIXED_FROM ||
      document.body.scrollTop > FIXED_FROM
    );
  }
  scrollHandler() {
    let me = this,
      navPanel = me.navPanelCmp.current,
      mode = navPanel.getMode();
    me.setState({ sidenavMode: mode });
  }
  setLeftMarginVisible(visible) {
    this.setState({ withLeftMargin: visible });
  }
  /**
   *
   * @param {string} mode hidden|fixed|docked
   */
  setSidenavMode(mode) {
    this.setState({ sidenavMode: mode });
  }

  toggleMenu() {
    this.navPanelCmp.current.toggle();
  }
  isNavbarHidden() {
    return this.navPanelCmp.current.isHidden();
  }
}
export default PaginaPrincipal;
